<template>
  <div>
    <v-centerForm>
      <template slot='left'>
        <el-form inline :model="searchForm" ref="searchForm" label-width="100px">
          <el-form-item label="支付流水号" prop="flowNo">
            <el-input placeholder="请输入支付流水号" v-model="searchForm.flowNo" clearable></el-input>
          </el-form-item>
          <el-form-item label="业务ID" prop="businessId">
            <el-input placeholder="请输入业务ID（订单号）" v-model="searchForm.businessId" clearable></el-input>
          </el-form-item>
          <el-form-item label="业务类型" prop="businessType">
            <el-select v-model="searchForm.businessType" placeholder="请选择业务类型" clearable>
              <el-option label="tinggo机票" value="1"></el-option>
              <el-option label="51kongtie机票" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付平台" prop="payPlatform">
            <el-select v-model="searchForm.payPlatform" placeholder="请选择支付平台" clearable>
              <el-option label="2c2p" value="1"></el-option>
              <el-option label="airwallex" value="2"></el-option>
              <el-option label="cash" value="3"></el-option>
              <el-option label="wechat" value="4"></el-option>
              <el-option label="alipay" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="币种" prop="currencyCode">
            <el-input placeholder="请输入币种" v-model="searchForm.currencyCode" clearable></el-input>
          </el-form-item>
          <el-form-item label="支付状态" prop="payStatus">
            <el-select v-model="searchForm.payStatus" placeholder="请选择支付状态" clearable>
              <el-option label="待支付" :value="0"></el-option>
              <el-option label="支付中" :value="1"></el-option>
              <el-option label="成功" :value="2"></el-option>
              <el-option label="失败" :value="3"></el-option>
              <el-option label="超时" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="searchForm.addTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="支付完成时间">
            <el-date-picker
              v-model="searchForm.payFinishTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="search-buttons">
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template slot='right'>
        <el-button icon="el-icon-refresh" @click="refresh">刷新</el-button>
      </template>
    </v-centerForm>

    <v-tableEncapsulation
      :loading="loadingBtn.tableLoading"
      :columnData="columnData"
      :tableSize="pagination.size"
      :tableData="tableData"
      :tableTotal="pagination.total"
      :currentPage="pagination.current"
      @currentPage="handleCurrentChange"
      @sizeChange="handleSizeChange">
      <el-table-column slot="payStatus" label="支付状态" align="center" width="100px">
        <template slot-scope="scope">
          <el-tag :type="getPayStatusTagType(scope.row.payStatus)" effect="dark">
            {{ scope.row.payStatusText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column slot="operate" label="操作" align="center" width="100px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </v-tableEncapsulation>

    <!-- 详情弹窗 -->
    <el-dialog title="交易记录详情" :visible.sync="detailDialogVisible" width="800px">
      <el-descriptions :column="2" border v-if="transactionDetail.flowNo">
        <el-descriptions-item label="支付流水号">{{ transactionDetail.flowNo }}</el-descriptions-item>
        <el-descriptions-item label="业务ID">{{ transactionDetail.businessId }}</el-descriptions-item>
        <el-descriptions-item label="业务类型">{{ transactionDetail.businessTypeText }}</el-descriptions-item>
        <el-descriptions-item label="支付平台">{{ transactionDetail.payPlatformText }}</el-descriptions-item>
        <el-descriptions-item label="币种">{{ transactionDetail.currencyCode }}</el-descriptions-item>
        <el-descriptions-item label="支付金额">${{ transactionDetail.amount }}</el-descriptions-item>
        <el-descriptions-item label="支付模式">{{ transactionDetail.payMode }}</el-descriptions-item>
        <el-descriptions-item label="支付状态">
          <el-tag :type="getPayStatusTagType(transactionDetail.payStatus)" effect="dark">
            {{ transactionDetail.payStatusText }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="资金商户ID">{{ transactionDetail.cashCustId }}</el-descriptions-item>
        <el-descriptions-item label="资金商户名称">{{ transactionDetail.cashCustName }}</el-descriptions-item>
        <el-descriptions-item label="资金交易编码">{{ transactionDetail.cashTradeNo }}</el-descriptions-item>
        <el-descriptions-item label="资金交易流水号">{{ transactionDetail.cashTradeLiushuihao }}</el-descriptions-item>
        <el-descriptions-item label="支付完成时间">{{ transactionDetail.payFinishTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ transactionDetail.addTime }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { queryTransactionList, queryTransactionDetail } from '@/api/finance/financeApi'

export default {
  name: 'transactionList',

  data () {
    return {
      searchForm: {
        flowNo: null,
        businessId: null,
        businessType: null,
        payPlatform: null,
        currencyCode: null,
        payStatus: null,
        addTimeRange: null,
        payFinishTimeRange: null
      },
      loadingBtn: {
        tableLoading: false
      },
      columnData: [
        {
          type: 'index',
          label: '序号',
          width: '60px'
        },
        {
          label: '支付流水号',
          prop: 'flowNo',
          width: '180px'
        },
        {
          label: '业务ID',
          prop: 'businessId',
          width: '180px'
        },
        {
          label: '业务类型',
          prop: 'businessTypeText',
          width: '120px'
        },
        {
          label: '支付平台',
          prop: 'payPlatformText',
          width: '120px'
        },
        {
          label: '币种',
          prop: 'currencyCode',
          width: '80px'
        },
        {
          label: '支付金额',
          prop: 'amount',
          width: '120px'
        },
        {
          label: '支付模式',
          prop: 'payMode',
          width: '150px'
        },
        {
          slot: 'payStatus'
        },
        // {
        //   label: '资金商户ID',
        //   prop: 'cashCustId',
        //   width: '150px'
        // },
        // {
        //   label: '资金商户名称',
        //   prop: 'cashCustName',
        //   width: '150px'
        // },
        // {
        //   label: '资金交易编码',
        //   prop: 'cashTradeNo',
        //   width: '150px'
        // },
        // {
        //   label: '资金交易流水号',
        //   prop: 'cashTradeLiushuihao',
        //   width: '180px'
        // },
        {
          label: '支付完成时间',
          prop: 'payFinishTime',
          width: '160px'
        },
        {
          label: '创建时间',
          prop: 'addTime',
          width: '160px'
        },
        {
          label: '更新时间',
          prop: 'updateTime',
          width: '160px'
        },
        {
          slot: 'operate'
        }
      ],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      detailDialogVisible: false,
      transactionDetail: {}
    }
  },

  methods: {
    // 搜索
    search () {
      this.pagination.current = 1
      this.getTableData()
    },

    // 重置搜索
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.searchForm.addTimeRange = null
      this.searchForm.payFinishTimeRange = null
      this.pagination.current = 1
      this.getTableData()
    },

    // 刷新
    refresh () {
      this.getTableData()
    },

    // 获取表格数据
    getTableData () {
      this.loadingBtn.tableLoading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        ...this.searchForm
      }

      // 处理日期范围
      if (params.addTimeRange && params.addTimeRange.length === 2) {
        params.addTimeStart = params.addTimeRange[0]
        params.addTimeEnd = params.addTimeRange[1]
      }
      delete params.addTimeRange

      if (params.payFinishTimeRange && params.payFinishTimeRange.length === 2) {
        params.payFinishTimeStart = params.payFinishTimeRange[0]
        params.payFinishTimeEnd = params.payFinishTimeRange[1]
      }
      delete params.payFinishTimeRange

      // 移除空值
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === '' || params[key] === undefined) {
          delete params[key]
        }
      })

      queryTransactionList(params).then(({ data, code }) => {
        console.log('getTableData() API 返回数据:', data, 'code:', code)
        // 兼容后端返回 code 为 0 或 10000 的情况
        if (code === 0 || code === this.$constant.SUCCESS) {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        } else {
          console.error('getTableData() 返回码不匹配，code:', code)
        }
        this.loadingBtn.tableLoading = false
      }).catch((error) => {
        console.error('getTableData() API 请求失败:', error)
        this.loadingBtn.tableLoading = false
      })
    },

    // 页码变化
    handleCurrentChange (current) {
      this.pagination.current = current
      this.getTableData()
    },

    // 每页条数变化
    handleSizeChange (size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.getTableData()
    },

    // 查看详情
    viewDetail (row) {
      queryTransactionDetail(row.flowNo).then(({ data, code }) => {
        console.log('viewDetail() API 返回 code:', code)
        // 兼容后端返回 code 为 0 或 10000 的情况
        if (code === 0 || code === this.$constant.SUCCESS) {
          this.transactionDetail = data || {}
          this.detailDialogVisible = true
        } else {
          console.error('viewDetail() 返回码不匹配，code:', code)
        }
      })
    },

    // 获取支付状态标签类型
    getPayStatusTagType (status) {
      const statusMap = {
        0: 'info', // 待支付
        1: 'warning', // 支付中
        2: 'success', // 成功
        3: 'danger', // 失败
        4: 'warning' // 超时
      }
      return statusMap[status] || 'info'
    }
  },

  created () {
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
.search-buttons {
  width: 100%;
  display: block;
}
</style>
